export default "__VITE_ASSET__BEG18SyI__"